module.exports = __webpack_public_path__ + "img/ctm-call-circle.5ba247cf.svg";